var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-info-card"},[_c('div',{staticClass:"app-info-card__label"},[(_vm.icon)?_c('v-icon',{staticClass:"mr-1",attrs:{"size":"14"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1),_c('div',{staticClass:"app-info-card__value"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value || "—"))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }